/**
 * UK Lab Chairs — GA4 Custom Event Tracking
 *
 * Works with Shopify's Google & YouTube app + GTM coexistence.
 * Detects the active GA4 measurement ID from the page and passes
 * send_to on every event to bypass duplicate-container conflicts.
 *
 * Events fired here:
 *   quote_request_started   — modal opens OR quote page loads
 *   rfq_button_clicked      — any RFQ button, param: button_location
 *   cart_delivery_answered  — forklift radio answered on cart page
 *   phone_click             — any tel: link clicked
 *   email_click             — any mailto: link clicked
 *
 * NOT fired here (already in quote-page.js):
 *   quote_request_submitted
 */
(function () {
  'use strict';

  var GA4_ID = 'G-FBY1J3ELWT';

  function track(eventName, params) {
    var p = {};
    for (var k in (params || {})) {
      if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
    }
    p.send_to = GA4_ID;

    if (window.dataLayer) {
      var payload = { event: eventName };
      for (var dk in p) { if (Object.prototype.hasOwnProperty.call(p, dk)) payload[dk] = p[dk]; }
      window.dataLayer.push(payload);
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, p);
    }
  }

  // Resolve button_location from data-rfq-location or fallback DOM position
  function rfqLocation(target) {
    var btn = target.closest('[data-rfq-location]');
    if (btn) return btn.dataset.rfqLocation;
    var footerLink = target.closest('a[href="/pages/request-for-quote"]');
    if (footerLink && footerLink.closest('footer, .footer')) return 'footer';
    return null;
  }

  // Single delegated listener for click-based events
  // Capture phase (true) fires before QLC app handlers that may stopPropagation
  document.addEventListener('click', function (e) {
    var t = e.target;

    // ── rfq_button_clicked ──────────────────────────────────────────────────
    var loc = rfqLocation(t);
    if (loc) {
      track('rfq_button_clicked', { button_location: loc });
    }

    // ── quote_request_started (modal path only) ─────────────────────────────
    var modalTrigger = t.closest('[data-qlc-trigger], [data-qlc-atq]');
    if (modalTrigger) {
      track('quote_request_started', { trigger_location: loc || 'unknown' });
    }

    // ── phone_click ─────────────────────────────────────────────────────────
    var telLink = t.closest('a[href^="tel:"]');
    if (telLink) {
      track('phone_click', { phone_number: telLink.href.replace('tel:', '') });
    }

    // ── email_click ─────────────────────────────────────────────────────────
    var mailLink = t.closest('a[href^="mailto:"]');
    if (mailLink) {
      track('email_click', { email_address: mailLink.href.replace('mailto:', '') });
    }
  }, true);

  // ── quote_request_started — quote page load ─────────────────────────────
  // Use window.load to ensure GA4 is fully initialised before firing
  if (window.location.pathname === '/pages/request-for-quote') {
    window.addEventListener('load', function () {
      track('quote_request_started', { trigger_location: 'direct_page' });
    });
  }

  // ── cart_delivery_answered ──────────────────────────────────────────────
  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (radio.type !== 'radio') return;
    if (radio.name === 'attributes[Forklift on site]') {
      track('cart_delivery_answered', { context: 'cart', forklift_answer: radio.value });
    }
  });

})();
